<template>
    <div class="sharer" v-on:click="shareSocial">
        <img class="img-fluid" v-bind:src="icon" />
        <span v-if="count">{{count}}
        </span>
    </div>
</template>

<script>
export default {
  name: 'socialsharer',
  props: ['title','share-url','social'],
  data: function () {
    return{
      count: undefined,
      url: SocialShares[this.social].url,
      share: SocialShares[this.social].share,
      icon: appData[this.social+'icon']
    }
  },
  methods: {
    shareSocial: function(data, el){
      window.open(
        this.share + this.shareUrl,
        '',
        'menubar=no,toolbar=no,resizable=yes' +
        ',scrollbars=yes' +
        ',height=300,width=600'
      );
    }
  },
  created: function () {
    var el = this;
    if(el.url && el.shareUrl){
      var url = el.url + el.shareUrl;
      var res = getScript(url,
        function(data, textStatus, jqxhr) {
          if(el.social == 'vk'){
            el.count = VK.Share.count;
          }
          if(el.social == 'od'){
            el.count = ODKL.count;
          }
        }
      )
    }
  }
}
</script>